import { useWebSocket } from "./WebSocket";

export async function sendButterflyCreated(id: number): Promise<void> {
  const message = { event: "butterflyCreated", id };
  await useWebSocket((socket) => {
    socket.sendObject(message);
  });
}
